import { createSlice } from '@reduxjs/toolkit';
import { TABLES } from '../types';

const tablesSlice = createSlice({
    name: TABLES,
    reducers: {
        getTablesRequest() {},
        getTablesSuccess(state, action) {
            const { data, count, totalCount } = action.payload;
            state.tablesData = data;
            state.tablesCounts = count;
            state.totalCount = totalCount;
        },
        setTableModalData(state, action) {
            state.tablesModalData = action.payload;
        },
        addTablesRequest() {},
        removeTablesRequest() {},
        setDownloadAllDetails(state, action) {
            Object.keys(action.payload).forEach((key) => {
                state.downloadAll[key] = action.payload[key];
            });
        },
        generatePdfRequest() {}
    },
    initialState: {
        tablesData: [],
        tablesModalData: false,
        tablesCounts: 0,
        totalCount: 0,
        tableUrl: '',
        downloadAll: {
            show: false,
            title: 'Download QR Codes',
            dataOptions: {
                note: {
                    name: 'note',
                    type: 'strong',
                    label: 'Note: Max 30 QR codes can be downloaded at once. Please adjust the table number range accordingly.',
                    className: 'text-center my-3 text-muted small'
                },
                start: {
                    name: 'start',
                    type: 'number',
                    label: 'Start Table Number',
                    className: 'col-6'
                },
                end: {
                    name: 'end',
                    type: 'number',
                    label: 'End Table Number',
                    className: 'col-6'
                }
            },
            start: 0,
            end: 0
        }
    }
});
export const {
    getTablesRequest,
    getTablesSuccess,
    setTableModalData,
    addTablesRequest,
    removeTablesRequest,
    setDownloadAllDetails,
    generatePdfRequest
} = tablesSlice.actions;

export const tablesReducer = tablesSlice.reducer;
